import React from 'react';
import FadeIn from 'react-fade-in';
import Lottie from 'react-lottie';
import 'bootstrap/dist/css/bootstrap.css';
import * as logoData from '../assets/lottie/logoloading.json';
import styled from 'styled-components';
import {Helmet} from 'react-helmet';
import Home from './home/Home';

const defaultOptions = {
	loop : true,
	autoplay: true,
	animationData: logoData.default,
	renderSettings:{
		preserveAspectRatio: "xMidYMid slice"
	}
};



// stylesheet
const StyledContainer = styled.div`
	background-color: ${props => props.theme.cyprus};

`; 


class Loading extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			done : undefined
		};
	}

	componentDidMount() {
    setTimeout(() => {
      
          setTimeout(() => {
            this.setState({ done: true });
          }, 3000);
        });
    }
  

	render() {
		return (
			<>
				<Helmet>
	                <style>{'body { background-color: #0A192F; }'}</style>
	               
	       		</Helmet>
				<StyledContainer>
					
						{!this.state.done ? (
							<FadeIn>
								<div className="">
									<Lottie options={defaultOptions} heigh={300} width={300} />
								</div>
							</FadeIn>
						) : (

								<Home />

							)}

				</StyledContainer>
			</>
			);
	}
}


export default Loading;